// extracted by mini-css-extract-plugin
export default {"hashControls":"PanelAddress_hashControls__-q4Pu","hashInput":"PanelAddress_hashInput__2r8Rq"};